module.exports = __webpack_public_path__ + "img/01d.2500771c.png";